
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z","fill":"#0491FF"}}),_c('path',{attrs:{"d":"M5.631 8.5c-.873 0-1.579.67-1.579 1.5 0 .655-.61 1-1.052 1 .484.61 1.31 1 2.105 1 1.163 0 2.105-.895 2.105-2 0-.83-.705-1.5-1.579-1.5zm7.215-4.684l-.705-.67a.544.544 0 00-.742 0l-4.715 4.48L8.13 9l4.715-4.479a.48.48 0 000-.705z","fill":"#fff"}})])
          )
        }
      }
    